export default __webpack_public_path__ + "static/media/lock_alert.8d9f0b9d.mp3";